import { DailyTourPlanning } from "@app/models";
import moment from 'moment';

export class OrderRequest {

    store: number;
    operation: number;
    profil: number;
    profilName: string;
    workerIdsToOfferMission: Array<number>;
    kit: number;

    reco: string;

    csPresence: boolean;
    appointment: string;
    sharingCustomerSectorContactDetailsToWorker: boolean;
    appointmentHour: string;
    appointmentMin: string;

    storeContact: string;
    mobileStoreContact: string;
    storeAccess: string;
    customerSector: number|null;
    missionOrderSource: string;

    planning: ActivityOrder[] = new Array();
    planningPurpose: number;
    plannedPurposes: PlanningMissionPurpose[];
    merchImplementationOption: number;
    
    dailyTourPlanning: number; 

    constructor() {
        this.planning = [];
    }

}

export class ActivityOrder {

    day: number;
    amStartHour: string;
    amStartMin: string;
    amDurationMin: number|null;

    pmStartHour: string;
    pmStartMin: string;
    pmDurationMin: number|null;

    earliestStartMin: number;
    latestStartMin: number;
    requestedDurationMin: number|null;
}

/**
 * Callback when a mission has been created
 */
export class MissionOrderCreateStatus {
    missions: number[];
    currentQuota: number;
    quota: number;
    quotaExceed: boolean;
    complianceInfringements: string[];
    quotaExcededDetails: string;
}

/**
 * Class to sublut a new Mission Cancellation
 */
export class SubmitMissionCustomerCancellation {
    comments: string;
}

export class TourPlanningDuplicateResponse {
    dailyTourPlanning: DailyTourPlanning;
    createStatuses: MissionOrderCreateStatus[] = [];
}

export class PlanningMissionPurpose {
    purposeId: number;
    instructions: string;
    id: number;
    purposeName: string;
}
